/*
 * Copyright © 2026 MS IMAGES. All rights reserved.
 * Proprietary and confidential — unauthorized copying, distribution, or use
 * of this file, via any medium, is strictly prohibited. See LICENSE.
 */

import { get } from '@/services/api/client';
import type { ApiResponse } from '@/types/api.types';

export interface DataAnomaly {
  id: string;
  category: string;
  severity: 'CRITICAL' | 'WARNING' | 'INFO';
  type: string;
  title: string;
  description: string;
  affectedEntity: string;
  affectedEntityId: string | null;
  orgId: string | null;
  orgName: string | null;
  suggestedAction: string;
  metadata: Record<string, unknown>;
}

export interface DataIntegrityScanResult {
  healthScore: number;
  healthLabel: string;
  totalAnomalies: number;
  countBySeverity: Record<string, number>;
  anomaliesByCategory: Record<string, DataAnomaly[]>;
  scannedAt: string;
  scanDurationMs: number;
}

const BASE_URL = '/admin/data-integrity';

export const dataIntegrityService = {
  async scan(): Promise<DataIntegrityScanResult> {
    const response = await get<ApiResponse<DataIntegrityScanResult>>(`${BASE_URL}/scan`);
    return response.data;
  },
};
